/**
 * Copyright 2024 Phenix Real Time Solutions, Inc. Confidential and Proprietary. All Rights Reserved.
 */

import {defaultDiscoveryUri} from '../defaults';
import Subject from '../../rx/Subject';
import VersionManager from '../version/VersionManager';
import Parameters from '../../environment/Parameters';

export default class DiscoveryUri {
  private static readonly _discoveryUri: Subject<string> = new Subject<string>(defaultDiscoveryUri);

  static get uri(): Subject<string> {
    return DiscoveryUri._discoveryUri;
  }

  static buildDiscoveryUrl(uri: URL): string {
    const url = new URL(uri.toString());
    const sdkVersion = VersionManager.sdkVersion;
    const intentions = Parameters.discoveryParameters.intentions;

    url.searchParams.set('version', sdkVersion);
    url.searchParams.set('intentions', intentions);
    url.searchParams.set('_', `${Date.now()}`);

    if (url.pathname === '/') {
      url.pathname = '/pcast/endPoints';
    }

    return url.toString();
  }

  private constructor() {
    throw new Error('DiscoveryUri is a static class that may not be instantiated');
  }
}